/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import rsaLogo from '../../../../assets/images/RSA_logo.png';
import React from 'react';
import AppHeader from '../../AppHeader/AppHeader';

export default function RsaHeader() {
  const rsaAppInfo = {
    imgSrc: rsaLogo,
    imgAlt: 'RSA Logo',
    headerTitle: 'RSA Authenticator',
    headerHelperText: 'Two-factor authentication'
  };

  return (
    <AppHeader appInfo={rsaAppInfo} />
  );
}
